import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import { useFeatureToggles } from '@grandvisionhq/state'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/contact-lens'
import { DeliveryIndicatorCLGraphContainer } from '@grandvisionhq/www-next/slot-components/DeliveryIndicatorGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'
import { getDeliveryIndicatorConfig } from '../../../configuration'
import { excludeSkuFromProductUrls } from '../../../configuration/manifest'
import { deliveryResolverFactory } from '../../../util/delivery-resolver-factory'

const slots: Props['slots'] = {
  BeforeUsps: () => (
    <DeliveryIndicatorCLGraphContainer deliveryResolverFactory={deliveryResolverFactory} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const { isDynamicLineItemDeliveryEstimationEnabled } = useFeatureToggles()
  if (isDynamicLineItemDeliveryEstimationEnabled) {
    slots.BeforeUsps = undefined
  }
  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      maxOrderableQuantity={cartSettings.maximumQuantity}
    />
  )
}

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  ProductDetailPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { excludeSkuFromProductUrls } })
}

export default composePDP<Props>(ProductDetailPage)
